var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 36,
    height: 36,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 32,
    height: 6,
    rx: 1,
    fill: "#c62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22 H42 V46 H4 Z",
    fill: "#c62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 26 H53 L60 35 V46 H42 Z",
    fill: "#c62828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 22,
    width: 7,
    height: 4,
    rx: 1,
    fill: "#c62828"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 47,
    r: 6,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 47,
    r: 6,
    fill: "#263238"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 H52 L56.5 35 H45 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 37,
    width: 38,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 47,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 47,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireTruck);
export default __webpack_public_path__ + "static/media/fire-truck.ce7c0183aae2c9a3fedfd8899537c498.svg";
export { ForwardRef as ReactComponent };